export default __webpack_public_path__ + "static/media/gearIcon.e03ae1fd.PNG";